function showToast(message, type = 'error') {
  let toastContainer = document.getElementById('toast-container');

  let toast = document.createElement('div');
  toast.className = 'toast ' + (type === 'success' ? 'success' : 'error');
  toast.innerText = message;

  toastContainer.prepend(toast);

  setTimeout(function () {
    toast.classList.add('hide');
    setTimeout(function () {
      toast.remove();
    }, 500);
  }, 1000);
}
